import { NextSeo } from 'next-seo';

//screens
import { YardTaskOrchestration } from '@/screens/Agents/YardTaskOrchestration';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function YardTaskOrchestrationPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/yard-task-orchestration/"
        title="Yard Task Orchestration Agent | Loadsmart AI"
        description="Creates and assigns yard tasks in the right order when an event calls for one, such as a truck arriving after hours or a container sitting too long, and tells suppliers and carriers when something needs their attention."
        openGraph={{
          url: 'https://loadsmart.com/ai/yard-task-orchestration/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/ai/yard-task-orchestration.png`,
              width: 1200,
              height: 630,
              alt: 'Yard Task Orchestration Agent',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <YardTaskOrchestration />
    </>
  );
}
